{
  "id": "interstellar-2014",
  "slug": "interstellar-2014",
  "title": "بين النجوم",
  "title_fr": "Interstellar",
  "original_title": "Interstellar",
  "description": "فريق من المستكشفين يسافرون عبر ثقب دودي بحثاً عن موطن جديد للبشرية.",
  "description_en": "A team of explorers travel through a wormhole in space in an attempt to ensure humanity's survival.",
  "description_fr": "Une équipe d'explorateurs voyage à travers un trou de ver dans l'espace pour assurer la survie de l'humanité.",
  "year": 2014,
  "release_date": "2014-11-07",
  "duration": "2h 49m",
  "duration_minutes": 169,
  "genres": [
    "Sci-Fi",
    "Drama",
    "Adventure"
  ],
  "genres_ar": [
    "خيال علمي",
    "دراما",
    "مغامرة"
  ],
  "genres_fr": [
    "Science-fiction",
    "Drame",
    "Aventure"
  ],
  "country": "US",
  "rating": 8.7,
  "cast": [
    "Matthew McConaughey",
    "Anne Hathaway",
    "Jessica Chastain"
  ],
  "director": "Christopher Nolan",
  "poster": "https://image.tmdb.org/t/p/w500/gEU2QniE6E77NI6lCU6MxlNBvIx.jpg",
  "backdrop": "https://image.tmdb.org/t/p/original/pbrkL804c8yAv3zBZR4QPEafpAR.jpg",
  "trailer_url": "https://www.youtube.com/watch?v=zSWdZVtXT7E",
  "tags": [
    "space",
    "time",
    "nolan"
  ],
  "is_trending": true,
  "is_new": true,
  "video_source": {
    "type": "external",
    "source_id": "interstellar-2014-main",
    "protected": true
  },
  "watch_url": "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  "watch_token": "bZR3rUICpB-_UzXxxBYrgo8Ck_mQb13YPgC2zdaYDPH9r0svsq7vMKM8vwEGDjtABnyccOkljxDQ_qHpxHI0W0l361Ecm45DRLlQuKYN_9rSmSxk6lLC6vqmvciktwmXaMdASbeB4nZvgNfHKm4xhhdEaN3FBl2LkOh1zOCFVWeVUy64ppdB_NBF-4p-69yUm_jexVbd9BdU9uBzfGA-frXnahNDL_ID1l3oo9t2wOK9w2W-hJzRuFS6aMVsqfcYTT2S_tmLUKCS8rS0uBmAvG5ZPirSLGkPP_Z6AJct_Ovo7C3d_1BM0LvuirQZlKD60X23FvXQUI1eyB4oHFIGyue7xe4Q3tN5X22zlaj8WKn-tAMHcWLFg7N8bKATYuuUnt-Q-nFRbx_bzSM93Hs6bShlvkQ_X8-9JdeqgX_lVIolHt2Vv0p7ISJra87JTQ"
}